// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UAdnV","content":"styles_content__9eVS6"};